//#region src/variants/variants_modal.js
var variants_modal_default = {
	default: {
		props: {
			headerText: { initialValue: "Example title" },
			copy: { initialValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." }
		},
		slots: { footer: { initialValue: "<dt-button importance=\"clear\">Cancel</dt-button><dt-button importance=\"primary\" class=\"d-mis-75\">Confirm</dt-button>" } }
	},
	danger: {
		props: {
			headerText: { initialValue: "Example title" },
			copy: { initialValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
			kind: { initialValue: "danger" }
		},
		slots: { footer: { initialValue: "<dt-button importance=\"clear\">Cancel</dt-button><dt-button kind=\"danger\" importance=\"primary\" class=\"d-mis-75\">Confirm</dt-button>" } }
	}
};
//#endregion
export { variants_modal_default as default };

//# sourceMappingURL=variants_modal.js.map